import { useEffect, useRef, useState } from 'react';

function useListFocusHandlers() {
  const [focusIndex, setFocusIndex] = useState(-1);

  function onLoadMore({ oldIndex }) {
    setFocusIndex(oldIndex);
  }

  function onChangeSorting() {
    setFocusIndex(0);
  }

  return {
    focusIndex,
    setFocusIndex,
    onChangeSorting,
    onLoadMore,
  };
}

function useListItemFocus({ data, focusIndex = -1, setFocusIndex = () => {} }) {
  const listItemRef = useRef(null);
  const nextFocusIndex = data && data[focusIndex] ? data[focusIndex].index : null;

  useEffect(() => {
    if (listItemRef.current) {
      listItemRef.current.focus();
      setFocusIndex(-1);
    }
    // eslint-disable-next-line
  }, [data]);

  return [nextFocusIndex, listItemRef];
}

export { useListItemFocus, useListFocusHandlers };
